export function Notifications({ state, payload, action }) {
  switch (action) {
    case 'LOAD_NOTIFICATIONS':
      return { ...state, Notifications: payload };
    default:
      return { ...state };
  }
}
